import { render } from "./CalendarTabView2.vue?vue&type=template&id=04e6c8a2"
import script from "./CalendarTabView2.vue?vue&type=script&lang=js"
export * from "./CalendarTabView2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__